module.exports = "<div class=\"modal-rename\" [ngClass]=\"class\" [ngStyle]=\"{display: display}\">\n    <div class=\"modal-rename-fon\">\n        <h6 [textContent]=\"'Rename ' + title\">Rename</h6>\n\n        <input type=\"text\" [(ngModel)]=\"name\" />\n        <button id=\"save-edit\" class=\"save\" (click)=\"Save()\">Save</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/rename/html/rename.component.html
// module id = ./src/app/components/rename/html/rename.component.html
// module chunks = main